import { getStatusColor, getStatusForeColor, getStatusLabel } from '@/utils';
import { Person as PersonIcon } from '@mui/icons-material';
import {
  Avatar,
  Box,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import { RadioHandheld as RadioHandheldIcon } from 'mdi-material-ui';

export function PersonListItem({ item, feature, ...props }) {
  const primary = feature.properties.person?.code
    ? [feature.properties.person?.forenames, feature.properties.person?.surname]
        .filter(Boolean)
        .join(' ')
        .trim()
    : 'Unassigned radio';
  const secondary = feature.properties.person?.code ?? feature.properties.ssi;

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
    >
      <Box sx={{ pr: 1 }}>
        <Tooltip
          title={getStatusLabel(feature.properties.status)}
          placement="top"
        >
          <Avatar
            sx={{
              color: getStatusForeColor(feature.properties.status ?? 'unknown'),
              bgcolor: getStatusColor(feature.properties.status ?? 'unknown'),
              borderColor: getStatusForeColor(
                feature.properties.status ?? 'unknown',
              ),
              borderWidth: 2,
              borderStyle: 'solid',
            }}
          >
            {feature.properties.person?.code ? (
              <PersonIcon />
            ) : (
              <RadioHandheldIcon />
            )}
          </Avatar>
        </Tooltip>
      </Box>
      <ListItemText
        primary={primary}
        secondary={secondary}
        slotProps={{
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
      {feature.properties.person?.collarNumber && (
        <Tooltip title="Collar Number" placement="right">
          <Box
            sx={{
              fontSize: 10,
              color: 'white',
              bgcolor: blue[900],
              borderRadius: 1,
              px: 0.5,
              py: 0.25,
            }}
          >
            {feature.properties.person?.collarNumber}
          </Box>
        </Tooltip>
      )}
    </ListItemButton>
  );
}
